import { IEnvironmentHostsConfig, Languages } from '../../interfaces/common'
import { DeployTypes } from '../../emun/DeployTypes'

export const lkHosts: IEnvironmentHostsConfig = {
  [DeployTypes.Development]: {
    [Languages.RU]: 'https://master-cabinet-lk.dev.lk.aservices.tech',
    [Languages.KZ]: 'https://master-cabinet-lk.dev.lk.aservices.tech',
    [Languages.UZ]: 'https://master-cabinet-lk.dev.lk.aservices.tech',
  },
  [DeployTypes.ReleaseCandidate]: {
    [Languages.RU]: 'https://stable-cabinet-lk.rc.lk.aservices.tech',
    [Languages.KZ]: 'https://stable-cabinet-lk.rc.lk.aservices.tech',
    [Languages.UZ]: 'https://stable-cabinet-lk.rc.lk.aservices.tech',
  },
  [DeployTypes.Production]: {
    [Languages.RU]: 'https://id2.action-media.ru',
    [Languages.KZ]: 'https://id.mcfr.kz',
    [Languages.UZ]: 'https://id.mcfr.uz',
  },
}
